import {
  LOGIN_DO_LOGIN_BEGIN,
  LOGIN_DO_LOGIN_SUCCESS,
  LOGIN_DO_LOGIN_FAILURE,
  LOGIN_DO_LOGIN_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function doLogin(usuario, args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    //Por seguridad no se guarda el password en el state, imagino que no es así!
    // //Obtenemos los datos del usuario a loguearse.
    // let usuario ={
    //   username: getState().home.usuario.username,
    //   password: getState().home.usuario.password
    // };

    // console.log(usuario);


    //Despachamos la accion que esta comenzando a loguearse enviando como payload el usuario.
    dispatch({
      type: LOGIN_DO_LOGIN_BEGIN,
      usuario: usuario
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      //Creamos primero la persona
      axios.post(SERVER_PATH + '/users/login', {
        user:usuario,
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          ///Por pruebas se simuló un response del API que se hará más adelante
           //Si usuario se ha creado correctamente.
          // console.log(res.data);
          if(res.data.success === 1)
          {
            res.data.username = usuario.username;
            dispatch({
              type: LOGIN_DO_LOGIN_SUCCESS,
              data: res.data,
            });
            resolve(res);
          }else{
            //Fallo al crear la usuario!
            dispatch({
              type: LOGIN_DO_LOGIN_FAILURE,
                data: { error: res.data.message},
            });
            reject("No se pudo crear el usuario");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: LOGIN_DO_LOGIN_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDoLoginError() {
  return {
    type: LOGIN_DO_LOGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_DO_LOGIN_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        doLoginPending: true,
        doLoginError: null,
      };

    case LOGIN_DO_LOGIN_SUCCESS:
      // The request is success
      let logged = action.data.success === 1? true:false;
      // The request is success
      if(logged)
      {
        localStorage.setItem("logged", logged);
        localStorage.setItem("username", action.data.username);
        localStorage.setItem("user_token", action.data.users.token);
        localStorage.setItem("user_id", action.data.users.user);
        localStorage.setItem("role", action.data.users.role);
        localStorage.setItem("avatar",action.data.users.avatar);
      } 
         
      //El estado cambia con la bandera logged que está ahora logueado el usuario
      return {
        ...state,
        openAlert:!logged,
        logged: logged,
        doLoginPending: false,
        doLoginError: null,
      };

    case LOGIN_DO_LOGIN_FAILURE:
      // The request is failed
      return {
        ...state,
        doLoginPending: false,
        logged: false,
        openAlert:true,
        doLoginError: action.data.error,
      };

    case LOGIN_DO_LOGIN_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        logged:false,
        doLoginError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login/redux/doLogin.js